import Button from '@components/atoms/button'
import { FastlyImage } from '@components/common/image'

export type ToolCardData = {
  title: string
  description: string
  image: string
}

type ExploreToolsProps = {
  title?: string
  description?: string
  urlQuery?: string
  tools: ToolCardData[]
  note?: string
}

const ToolCard = ({ card }: { card: ToolCardData }) => (
  <div className="bg-white rounded-xl border border-grey-100 shadow-sm overflow-hidden hover:shadow-md transition-shadow flex flex-col mx-auto w-full">
    <div className="relative w-full bg-grey-50">
      <FastlyImage
        src={card.image}
        alt={card.title}
        width={400}
        height={225}
        layout="responsive"
        objectFit="cover"
      />
    </div>
    <div className="p-2 lg:p-4 flex flex-col flex-1">
      <h3 className="font-600 text-lg leading-snug mb-2 text-grey">
        {card.title}
      </h3>
      <p className="text-sm text-grey-800 flex-1 leading-relaxed">
        {card.description}
      </p>
    </div>
  </div>
)

const ExploreTools = ({
  title,
  description,
  urlQuery = '',
  tools,
  note,
}: ExploreToolsProps) => {
  const trialLink = `/register/${urlQuery}`

  return (
    <div className="my-10 lg:px-3 py-5 flex flex-col text-grey-900">
      {title && (
        <h2 className="text-2xl font-600 mb-4 leading-tight">{title}</h2>
      )}
      {description && <p className="lg:text-lg mt-2 mb-6">{description}</p>}

      <div className="grid grid-cols-2 lg:grid-cols-3 gap-2 justify-center mt-6 mb-8">
        {tools.map((card, index) => (
          <ToolCard key={index} card={card} />
        ))}
      </div>

      {note && (
        <div className="bg-yellow-100 bg-opacity-50 rounded-md p-2 text-sm text-grey mb-8 w-fit">
          {note}
        </div>
      )}

      <div className="flex flex-col lg:flex-row justify-center gap-4 w-full">
        <a
          href={trialLink}
          target="_blank"
          rel="noopener noreferrer"
          className="w-full lg:w-auto"
        >
          <Button size="lg" className="w-full lg:w-auto">
            Try a free lesson
          </Button>
        </a>
        <a
          href="/courses/"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full lg:w-auto"
        >
          <Button size="lg" variant="outline" className="w-full lg:w-auto">
            Browse all courses
          </Button>
        </a>
      </div>
    </div>
  )
}

export default ExploreTools
